import { createVNode as o, mergeProps as d } from "vue";
import l from "../node_modules/@pf-ui/pf-icon-svg/es/asn/ChartFilledStandard.js";
import i from "../components/PfIcon.js";
const r = (t, a) => {
  const e = {
    ...t,
    ...a.attrs
  };
  return o(i, d(e, {
    icon: l
  }), null);
};
r.displayName = "ChartFilledStandard";
r.inheritAttrs = !1;
export {
  r as default
};
